/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useObservable } from '@squiz/dxp-console-support';
import { useConsoleServiceStore } from 'dxpConsoleCore-mf/State';
import { useMemo } from 'react';
import { Observable } from 'rxjs';
import {
  ConsoleInstanceListPurpose,
  ConsoleInstanceStatusCode,
  ConsoleInstanceType,
  EntityConsoleInstance,
  EntityDxpUserMeOrganisation,
} from '../../Entities';
import { getConsoleService } from '../../Utilities/GetConsoleService/GetConsoleService';

/**
 * React hook to obtain a list of product instances with information from the console service.
 */
export function useInstances(
  typeFilter?: ConsoleInstanceType,
  statusFilter?: ConsoleInstanceStatusCode,
  purpose?: ConsoleInstanceListPurpose,
): Array<EntityConsoleInstance> | null {
  const consoleService = getConsoleService();
  const { tenant }: { tenant: EntityDxpUserMeOrganisation } = useConsoleServiceStore();
  const { organisationId } = tenant;

  const productInstances$ = useMemo((): Observable<Array<EntityConsoleInstance>> => {
    return consoleService.getProductInstances({ organisationId, purpose, statusFilter, typeFilter });
  }, [consoleService, organisationId, purpose, statusFilter, typeFilter]);

  const [productInstances] = useObservable(productInstances$, [consoleService, organisationId]);
  return productInstances;
}
